module.exports = __webpack_public_path__ + "static/media/ZhiXiao1.ef80444c.png";